export const isNotNullOrUndefined = <T>(v: T | null): v is T => {
  return !(v === null || v === undefined);
};
